export enum AuthenticationScheme {
  BASIC = 'basic',
  OAUTH = 'oauth',
  OAUTH_CLIENT_CREDENTIAL = 'oauth_client_credential',
  SERVICE_ACCOUNT = 'service_account',
  OAUTH_APP = 'oauth_app',
  IMPERSONATED_APP = 'impersonated_app',
}

/**
 * oauth response return from our service
 */
export type OauthCallbackResponse = {
  integrationId: string;
  payload: Record<string, string | number | boolean | any>;
};
